import { EmptyState } from "@/components/brand/EmptyState";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

/** Shown on property-scoped admin screens when no property is selected yet. */
export function NoPropertySelected() {
  return (
    <EmptyState
      title="숙소를 먼저 선택/등록하세요"
      description="사이드바 상단에서 숙소를 선택하거나, 숙소 관리에서 새 숙소를 등록하세요."
      action={
        <Button asChild>
          <Link to="/admin/properties">숙소 관리로 이동</Link>
        </Button>
      }
    />
  );
}
